import { combineReducers } from 'redux';
import jobs from './modelFactorySlice';
import site from './siteSlice';

// State used by the App Onu (host) application
export default combineReducers({
  jobs,
  site,
});
export const moduleNamespace = 'modelFactory';
